import React, { useState } from 'react';
import styled from 'styled-components';

const Radio = ({ options = [], name = 'radio-group', onChange }) => {
  const defaultIndex = Math.max(options.findIndex(o => o.defaultChecked), 0);
  const [selectedIndex, setSelectedIndex] = useState(defaultIndex);

  const handleChange = (index, value) => {
    setSelectedIndex(index);
    if (onChange) onChange(value, index);
  };

  return (
    <StyledWrapper>
      <div className="glass-radio-group">
        {options.map((opt, i) => (
          <React.Fragment key={i}>
            <input
              type="radio"
              name={name}
              id={`${name}-${i}`}
              defaultChecked={opt.defaultChecked}
              onChange={() => handleChange(i, opt.value)}
            />
            <label htmlFor={`${name}-${i}`}>{opt.label}</label>
          </React.Fragment>
        ))}
        <div
          className="glass-glider"
          style={{
            width: `calc(100% / ${options.length})`,
            transform: `translateX(${selectedIndex * 100}%)`,
          }}
        />
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .glass-radio-group {
    display: flex;
    position: relative;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 1rem;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    box-shadow:
      inset 1px 1px 4px rgba(255, 255, 255, 0.2),
      inset -1px -1px 6px rgba(0, 0, 0, 0.3),
      0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    width: fit-content;
  }

  .glass-radio-group input {
    display: none;
  }

  .glass-radio-group label {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    font-size: 13px;
    padding: 0.65rem 1.5rem;
    cursor: pointer;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: #c4b5fd;
    position: relative;
    z-index: 2;
    transition: color 0.3s ease-in-out;
    white-space: nowrap;
  }

  .glass-radio-group label:hover {
    color: #ffffff;
  }

  .glass-radio-group input:checked + label {
    color: #fff;
  }

  .glass-glider {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    border-radius: 1rem;
    z-index: 1;
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.7), rgba(168, 85, 247, 0.85));
    box-shadow:
      0 0 18px rgba(139, 92, 246, 0.5),
      0 0 10px rgba(168, 85, 247, 0.4) inset;
    transition:
      transform 0.5s cubic-bezier(0.37, 1.95, 0.66, 0.56),
      background 0.4s ease-in-out,
      box-shadow 0.4s ease-in-out;
  }
`;

export default Radio;
